import React, { useEffect, useState } from "react";

// Code-splitting helper WITHOUT React.lazy/Suspense.
// React.lazy's Suspense retry never fires in this build environment (the underlying
// dynamic import resolves, but the Suspense boundary is never pinged), so routes hang
// on the fallback forever. This performs the dynamic import() directly (proven to work)
// and swaps in the component once loaded — still emitting a separate webpack chunk.
const DefaultFallback = (
  <div
    className="min-h-screen flex items-center justify-center text-nj-muted"
    data-testid="route-loading"
  >
    Chargement…
  </div>
);

const ErrorFallback = (
  <div
    className="min-h-screen flex flex-col items-center justify-center gap-4 text-center px-6 text-nj-muted"
    data-testid="route-load-error"
  >
    <p>Le chargement de cette page a échoué.</p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="px-5 py-2.5 rounded-full bg-neutral-900 text-white text-sm"
      data-testid="route-reload-btn"
    >
      Recharger
    </button>
  </div>
);

export default function lazyLoad(factory, fallback = DefaultFallback) {
  return function Loadable(props) {
    const [Comp, setComp] = useState(null);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
      let alive = true;
      const attempt = (retriesLeft) =>
        factory()
          .then((m) => {
            if (alive) setComp(() => m.default);
          })
          .catch(() => {
            if (!alive) return;
            if (retriesLeft > 0) setTimeout(() => attempt(retriesLeft - 1), 800);
            else setFailed(true);
          });
      attempt(1);
      return () => {
        alive = false;
      };
    }, []);
    if (failed) return fallback === null ? null : ErrorFallback;
    return Comp ? <Comp {...props} /> : fallback;
  };
}
